import {
  Action,
  ActionType,
  IDeleteNotificationResponse,
} from "models/setting/deleteNotification";
import createReducer from "../../createReducer";

export interface DeleteNotificationReducerType {
  loading: boolean;
  error?: string;
  deleteNotificationResponse?: IDeleteNotificationResponse;
}

const defaultState: DeleteNotificationReducerType = {
  loading: false,
  error: undefined,
  deleteNotificationResponse: undefined,
};

export const deleteNotificationReducer =
  createReducer<DeleteNotificationReducerType>(defaultState, {
    [ActionType.DELETE_NOTIFICATION](state: DeleteNotificationReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DELETE_NOTIFICATION_ERROR](
      state: DeleteNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DELETE_NOTIFICATION_SUCCESS](
      state: DeleteNotificationReducerType,
      action: Action<IDeleteNotificationResponse>
    ) {
      return {
        ...state,
        loading: false,
        deleteNotificationResponse: action.payload,
      };
    },
  });
